"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "uzzano": {
    "e1458ad6": [{
      "hkey": "d14882e5",
      "slug": "sant-alluccio",
      "name": "Sant'Alluccio",
      "primary": true,
      "skipSearch": false
    }],
    "centri-abitati-sant-allucio": [{
      "hkey": "d14882e5",
      "slug": "sant-alluccio",
      "name": "Sant'Alluccio",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "250ae52b": [{
      "hkey": "1d55f9e1",
      "slug": "uzzano",
      "name": "Uzzano",
      "primary": true,
      "skipSearch": false
    }],
    "la-costa": [{
      "hkey": "1d55f9e1",
      "slug": "uzzano",
      "name": "Uzzano",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;